import React, { useState } from 'react';
import PasswordReset from './PasswordReset';
// import Alert from 'react-s-alert';
import { getCurrentUser, phonelogin } from '../APIUtils';
import { getLastPath, saveAuthentication, isAuthenticated, saveUserInfo, userInfo } from '../CookiesUtil';
import { useAppNavigation } from '../historyUtils';
import { useDispatch } from "react-redux";
import { login } from "src/store/reducers/authSlice";

interface LoginPhoneFormProps {
    onLogin: (userData: { email: string; name: string }) => void;
}

const LoginPhoneForm: React.FC<LoginPhoneFormProps> = ({ onLogin }) => {
    console.log("propssaas", onLogin);

    const [displayReset, setDisplayReset] = useState(false);
    const navigate = useAppNavigation();
    const dispatch = useDispatch();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const phoneInput = (document.getElementById("phone") as HTMLInputElement)?.value;
        const passwordInput = (document.getElementById("password") as HTMLInputElement)?.value;

        if (!phoneInput || !passwordInput) return;

        const loginRequest = { phone: phoneInput, password: passwordInput };

        phonelogin(loginRequest)
            .then(response => {
                saveAuthentication(response.accessToken);
                // Alert.success("You're successfully logged in!");
                console.log("this.response", response);

                getCurrentUser()
                    .then(res => {
                        if (res) {
                            saveUserInfo(res);
                            dispatch(login(userInfo()));
                            onLogin(res);

                            const redirectPath = getLastPath() || "/profile";
                            navigate(redirectPath);
                        }
                    })
                    .catch(error => console.error("error:", error));
            })
            .catch(error => {
                // Alert.error("Please check your password and username!");
                // Alert.error(error?.message || 'Oops! Something went wrong. Please try again!');
            });
    };

    const handlePasswordReset = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setDisplayReset(!displayReset);
    };

    return (
        <div className="mt-3">
            {displayReset ? (
                <PasswordReset />
            ) : (
                <div>
                    <h1 className="text-2xl font-bold italic text-blue-500 mb-4">Login with Phone</h1>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-2">
                            <input type="number" name="phone" id="phone" className="w-full p-2 border rounded" placeholder="Phone" required />
                        </div>
                        <div className="mb-2">
                            <input type="password" name="password" id="password" className="w-full p-2 border rounded" placeholder="Password" required />
                        </div>
                        <div className="flex justify-start">
                            <button type="submit" className="bg-blue-500 text-white p-2 rounded mr-2">Login</button>
                            <button onClick={handlePasswordReset} className="border border-blue-500 text-blue-500 p-2 rounded">Reset Password</button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default LoginPhoneForm;